import apiDirectors from '../api/directors'
import apiBrokers from '../api/brokers'
import apiNews from '../api/news'
import apiImi from '../api/imi'
import api from '../api/ventures'
import { browserHistory } from 'react-router'
import { pick, paramsForProperties } from './api'
import { load } from './propiedades'
import * as urls from '../constants/api'

export const actionTypes = {
  RECEIVE_DIRECTORS: 'entrepreneurship/RECEIVE_DIRECTORS',
  RECEIVE_BROKERS: 'entrepreneurship/RECEIVE_BROKERS',
  RECEIVE_NEWS: 'entrepreneurship/RECEIVE_NEWS',
  RECEIVE_IMIS: 'entrepreneurship/RECEIVE_IMIS',
  RECEIVE_VENTURES_LANDINGS: 'entrepreneurship/RECEIVE_VENTURES_LANDINGS',
  RECEIVE_VENTURES_BY_ID: 'entrepreneurship/RECEIVE_VENTURES_BY_ID',
	RESET_ENTREPRENEURSHIP_ID: 'entrepreneurship/RESET_ENTREPRENEURSHIP_ID',
  VENTURES_LOADING: 'entrepreneurship/VENTURES_LOADING'
}

export const loadDirectorsBySector = (id) => {
  return(dispatch, getStore) => {
    apiDirectors.fetchDirectorsBySector(id)
      .then((data) => dispatch(receiveDirectors(data)))
  }
}

function receiveDirectors(APIdata) {
  return {
    type: actionTypes.RECEIVE_DIRECTORS,
    data: APIdata.data
  }
}

export const loadBrokers = (id) => {
  return(dispatch, getStore) => {
    apiBrokers.fetchBrokers(id)
      .then((data) => dispatch(receiveBrokers(data)))
  }
}

function receiveBrokers(APIdata) {
  return {
    type: actionTypes.RECEIVE_BROKERS,
    data: APIdata.data
  }
}

export const loadNewsBySector = (id) => {
  return(dispatch, getStore) => {
    apiNews.fetchNewsBySector(id)
      .then((data) => dispatch(receiveNews(data)))
  }
}

function receiveNews(APIdata) {
  return {
    type: actionTypes.RECEIVE_NEWS,
    data: APIdata
  }
}

export const loadImisBySector = (id) => {
  return(dispatch, getStore) => {
    apiImi.fetchImisBySector(id)
      .then((data) => dispatch(receiveImis(data)))
  }
}

function receiveImis(APIdata) {
  return {
    type: actionTypes.RECEIVE_IMIS,
    data: APIdata.data
  }
}

export const resetEntrepreneurshipId = () => {
	return	{
		type: actionTypes.RESET_ENTREPRENEURSHIP_ID
	}
}

export const loadVentures = (pl) => {
  return(dispatch, getStore) => {
    api.fetchVentures(pl)
      .then((data) => dispatch(receiveVentures(data)))
  }
}

function receiveVentures(APIdata) {
  return {
    type: actionTypes.RECEIVE_VENTURES_LANDINGS,
    data: APIdata
  }
}

export const loadVenturesById = (id) => {
  return (dispatch, getStore) => {
    dispatch(setVentureId(id))
    dispatch(redirectWithParams(getStore()))
    // dispatch(load(urls.PROPERTIES));
  }
}

function redirectWithParams (store) {
  let nq = JSON.stringify(pick(paramsForProperties(store)))
  browserHistory.push('/propiedades?q='+JSON.stringify(pick(paramsForProperties(store))))
  return {
    type: actionTypes.VENTURES_LOADING
  }
}

export const setVentureId = (value) => {
  return {
    type: actionTypes.RECEIVE_VENTURES_BY_ID,
    value
  }
}



// WEBPACK FOOTER //
// ./src/actions/entrepreneurship.js